import Model from 'models';

const DYRecommendationsModel = class extends Model {
  get title() {
    return this._data?.variations?.[0]?.payload?.data?.custom?.title || null;
  }

  get products() {
    return this._data?.variations?.[0]?.payload?.data?.slots || [];
  }

  get uniqueProductsByHandle() {
    return (this.products || []).reduce(
      (acc, slot) => {
        const handle = slot?.productData?.handle;

        if (handle && !acc.handles.has(handle)) {
          acc.handles.add(handle);
          acc.slots.push(slot);
        }

        return acc;
      },
      { handles: new Set(), slots: [] }
    ).slots;
  }

  get showColorway() {
    return this._data?.variations?.[0]?.payload?.data?.custom?.showColorway === 'true';
  }

  get showPrice() {
    return this._data?.variations?.[0]?.payload?.data?.custom?.showPrice === 'true';
  }

  get variationId() {
    return this._data?.variations?.[0]?.id || null;
  }

  get decisionId() {
    return this._data?.decisionId || null;
  }
};

export default DYRecommendationsModel;
